import ImportHelper from './import.helper'


/*Precondicion: solo un video en la carpeta*/

//const AllTransitions = () => { return ImportHelper.importAll(require.context("../assets/videos/", true, /\.mp4/)); }

export const ContextTransitions = {
    "Etapa 1": { initFrame:  25 },
    "Torre 1": { initFrame:  0 },
    "Torre 2": { initFrame:  0 },
    "Portería 2": { initFrame:  10 },
    "Portería 1": { initFrame:  50 },
    "Salón 2": { initFrame:  130 },
    "Juego de niños": { initFrame:  72 },
    "Terraza": { initFrame:  49 },
    "Yoga": { initFrame:  123 },
    "BBQ": { initFrame:  125 },
    "Mascotas": { initFrame:  127 },
    "Mirador": { initFrame:  123 },
    "Calistenia": { initFrame:  123 },
    "Gimnasio": { initFrame:  123 },
    "Salón de reuniones": { initFrame:  40 },
    "Área coworking": { initFrame:  123 },
    "Sala lúdica infantes": { initFrame:  3 },
    "Terraza comtemplativa": { initFrame:  123 },

    //"EveryTransition": { importTransition: AllTransitions }
}
